export const businessServiceCards = [
  {
    title: 'Staff Phone Repairs',
    description:
      'Fast repair support for employee iPhones, Samsung phones, and other work devices that need to get back into service quickly.',
    icon: 'M7 2h10a2 2 0 012 2v16a2 2 0 01-2 2H7a2 2 0 01-2-2V4a2 2 0 012-2zm5 15h.01',
  },
  {
    title: 'Tablet and iPad Repairs',
    description:
      'We handle cracked screens, charging issues, battery problems, and diagnostics for tablets used in sales, service, and operations.',
    icon: 'M6 4h12a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2zm6 11h.01',
  },
  {
    title: 'Laptop Repairs',
    description:
      'Support for business laptops with screen damage, battery concerns, charging issues, and software problems.',
    icon: 'M4 6h16v10H4zm-2 12h20',
  },
  {
    title: 'Priority Repair Support',
    description:
      'Business inquiries are handled with clear communication, quick assessment, and practical next steps to reduce downtime.',
    icon: 'M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z',
  },
  {
    title: 'Pickup and Drop Service',
    description:
      'Convenient collection and return options are available across Kitchener, Waterloo, and Cambridge when schedules require it.',
    icon: 'M9 17H6a2 2 0 01-2-2V7a2 2 0 012-2h2m3 12h4m5 0h1a2 2 0 002-2v-3l-3-4h-3m-6 0V5a2 2 0 012-2h6a2 2 0 012 2v12m-8 0a2 2 0 104 0 2 2 0 10-4 0m8 0a2 2 0 104 0 2 2 0 10-4 0',
  },
  {
    title: 'Multiple Device Handling',
    description:
      'We support one-off repairs and batches of devices for offices, field teams, property managers, and growing businesses.',
    icon: 'M4 7h10v10H4zm6-3h10v10H10zM8 17h12v3H8z',
  },
  {
    title: 'Diagnostics and Maintenance',
    description:
      'Not every issue needs a major repair. We diagnose faults, identify the cause, and recommend the right fix before work begins.',
    icon: 'M10 3H5a2 2 0 00-2 2v5m18 4v5a2 2 0 01-2 2h-5M14 21h-4m2-18a7 7 0 110 14 7 7 0 010-14z',
  },
  {
    title: 'Warranty-Backed Repairs',
    description:
      'Repairs are completed with care and backed by warranty support for added confidence after the device is returned.',
    icon: 'M12 3l7 4v5c0 5-3.5 8-7 9-3.5-1-7-4-7-9V7l7-4z',
  },
];

export const businessReasons = [
  {
    title: 'Fast turnaround',
    description: 'We focus on practical repair timelines so your team can get devices back quickly.',
    icon: 'M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z',
  },
  {
    title: 'Priority support',
    description:
      'Business requests are handled with urgency and straightforward updates from first contact to return.',
    icon: 'M13 10V3L4 14h7v7l9-11h-7z',
  },
  {
    title: 'Pickup and drop available',
    description:
      'We can arrange collection and return options when that is easier for your office or team.',
    icon: 'M9 17H6a2 2 0 01-2-2V7a2 2 0 012-2h2m3 12h4m5 0h1a2 2 0 002-2v-3l-3-4h-3m-6 0V5a2 2 0 012-2h6a2 2 0 012 2v12m-8 0a2 2 0 104 0 2 2 0 10-4 0m8 0a2 2 0 104 0 2 2 0 10-4 0',
  },
  {
    title: 'Local trusted service',
    description:
      'NSK Repair serves businesses across Kitchener, Waterloo, and Cambridge with local support you can reach easily.',
    icon: 'M12 2C8 2 5 5 5 9c0 5 7 13 7 13s7-8 7-13c0-4-3-7-7-7z',
  },
  {
    title: 'Warranty on repairs',
    description: 'Every approved repair is completed with warranty-backed support for extra peace of mind.',
    icon: 'M12 3l7 4v5c0 5-3.5 8-7 9-3.5-1-7-4-7-9V7l7-4z',
  },
  {
    title: 'Clear pricing and communication',
    description:
      'We explain the issue, share the repair plan, and keep pricing transparent before work starts.',
    icon: 'M7 8h10M7 12h6m-6 8h10a2 2 0 002-2V6a2 2 0 00-2-2H7a2 2 0 00-2 2v12a2 2 0 002 2z',
  },
];

export const industries = [
  'Real Estate Offices',
  'Construction Companies',
  'Delivery & Logistics',
  'Restaurants & Retail',
  'Property Management',
  'Small Offices',
  'Sales Teams',
  'Field Service Teams',
];

export const businessProcess = [
  {
    step: '01',
    title: 'Contact us',
    description: 'Call, email, or submit the business inquiry form with your repair needs.',
    icon: 'M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z',
    color: '#1E90FF',
  },
  {
    step: '02',
    title: 'We assess the issue',
    description: 'We review the devices, identify the problem, and confirm the best support option.',
    icon: 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z',
    color: '#FF6F00',
  },
  {
    step: '03',
    title: 'Pickup, drop off, or bring the device',
    description: 'Choose the most convenient way to get devices to us based on your schedule.',
    icon: 'M3 7h13v8H3zm13 2h3l2 3v3h-5zm-9 5a2 2 0 104 0 2 2 0 10-4 0m9 0a2 2 0 104 0 2 2 0 10-4 0',
    color: '#22C55E',
  },
  {
    step: '04',
    title: 'Repair and return',
    description: 'We complete the repair, test the device, and return it ready for work.',
    icon: 'M5 13l4 4L19 7',
    color: '#0F766E',
  },
];

export const businessTrustSignals = [
  'Local repair service in Kitchener-Waterloo-Cambridge',
  'Business-friendly support',
  'Warranty on repairs',
  'Fast response',
  'Professional diagnostics',
  'Transparent pricing',
];

export const businessTestimonialsPlaceholder = [
  {
    company: 'Placeholder Review',
    quote:
      'Example testimonial layout for future business reviews. This space can highlight turnaround time, communication, and overall service experience.',
  },
  {
    company: 'Placeholder Review',
    quote:
      'Example testimonial layout for offices, field teams, or local companies that need dependable repair support for multiple devices.',
  },
  {
    company: 'Placeholder Review',
    quote:
      'Example testimonial layout for future Google review integration or verified business case studies.',
  },
];
